// generated: 5/27/2026, 9:00:02 AM

export default {
    production: true,
    apiBasePath: 'https://api.car-tracking-online.com',
    region: 'eu-central-1',
    segmentWriteKey: '7kwUKn4tYo9cSd2LIBrh693MRIgNcSca',
    sendTrackingEvents: true
};
